<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>

      <el-button type="primary" @click.native="save" :disabled="data.Status == 2 || !canWrite">保存</el-button>
      <!--  @click.native="orderReview" -->
      <el-button
        type="primary"
        @click.native="orderReview"
        :disabled="!isSave || !canReview"
        >{{ ReviewName }}</el-button
      >
      <el-button type="primary" @click.native="orderDel" :disabled="data.Status == 2 || !isSave || !canWrite"
        >删除</el-button
      >
      <!-- <el-button @click="close">关 闭</el-button> -->
    </div>
    <el-form
      ref="dialog"
      :data="data"
      label-width="100px"
      :model="data"
      :rules="rules"
      :inline="true"
    >
      <div class="row-head">基本信息</div>
      <el-row class="border">
        <el-row :gutter="15">
          <el-form-item label="外协单位" prop="unit">
            <span class="not-edit" v-if="isDetails">{{
              data.TradeUnitName
            }}</span>
            <!-- <select-input
              v-else
              placeholder="请选择外协单位"
              :label="data.TradeUnitName"
              v-model="data.TradeUnitId"
              @click="openTradeunit"
            /> -->
            <el-select 
              v-else 
              v-model="data.TradeUnitId"
              filterable style="width: 180px">
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :value="item.TradeUnitId"
                :label="item.FullName"
                @click.native="setTradeunit(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据编号:" prop="DocNo">
            <span v-if="Mode == 0 || isDetails" class="not-edit">{{
              data.DocNo
            }}</span>
            <el-input
              v-else
              v-model="data.DocNo"
              style="width: 193px"
            ></el-input>
          </el-form-item>
          <el-form-item label="单据日期" prop="DocDate">
            <span class="not-edit" v-if="isDetails">{{
              $commonJs.toDateString(data.DocDate)
            }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => previewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
      </el-row>

      <div class="row-tb-head" style="margin-top: 10px">
        <span>明细列表</span>
        <div style="float: right">
          <el-button
            type="primary"
            v-if="!isDetails"
            icon="el-icon-plus"
            @click="add"
            >添加</el-button
          >
        </div>
      </div>
      <el-table
        class="table-line tb-c-head"
        show-summary
        :data="data.RpOutPocCostDts"
        border
      >
        <!-- <el-table-column label="生产阶段" min-width="90">
            <template slot-scope="{row}">
              <span v-if="row.Stage==0">注塑</span>
              <span v-if="row.Stage==1">胶件加工</span>
              <span v-if="row.Stage==2">配件装配</span>
              <span v-if="row.Stage==3">产品装配</span>
              <span v-if="row.Stage==4">产品组装</span>
            </template>
          </el-table-column>-->
        <el-table-column
          label="入库单号"
          min-width="180"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="{ row }">{{ row.InNumber }}</template>
        </el-table-column>
        <!-- <el-table-column label="工序" min-width="130" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.ProcessNo}}</template>
          </el-table-column>-->
        <el-table-column label="产品编号" min-width="150" align="center">
          <template slot-scope="{ row }">{{ row.ProductNo }}</template>
        </el-table-column>
        <el-table-column label="产品名称" min-width="150" align="center">
          <template slot-scope="{ row }">{{ row.ProductName }}</template>
        </el-table-column>
        <el-table-column
          label="产品规格"
          prop="ProductSpec"
          min-width="100"
          align="center"
        />
        <el-table-column
          label="产品单位"
          prop="UnitName"
          min-width="90"
          align="center"
        />
        <el-table-column
          label="属性"
          prop="PropertyName"
          min-width="90"
          align="center"
        />
        <el-table-column
          label="颜色"
          prop="ColorName"
          min-width="90"
          align="center"
        />
        <el-table-column
          label="数量"
          prop="Quantity"
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input
              v-else
              @input="onInput(row, 'Quantity')"
              v-model="row.Quantity"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="加工单价"
          prop="PocUnitPrice"
          width="120"
          align="center"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.PocUnitPrice }}</span>
            <el-input
              v-else
              @input="onInput(row, 'PocUnitPrice')"
              v-model="row.PocUnitPrice"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="加工金额"
          prop="PocAmount"
          width="120"
          align="center"
          v-if="canPrice"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="60px"
          v-if="!isDetails"
        >
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="del(row, $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <select-dialog ref="selectDialog" @select="setRows" />
    <!-- <common-dialog ref="dialog" width="850px" show-save-button unit="加工费用单" edit-title id-key="RegionId" :data="data"
      :line-form="true" form-label-width="85px" :form-rules="rules" :save-func="api.save" :before-save="onBeforeSave"
      @opened="onOpened" @edit-opened="onEditOpened" @closed="onClosed" @close-saved="$emit('close-saved')">
      <template slot="form">
        
      </template>
    </common-dialog> -->
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import selectDialog from "@/components/finance/dealings/machiningcost/selectDialog";

export default {
  name: "editMachiningCost",
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    tradeunitDialog,
    selectDialog,
  },
  data() {
    return {
      api: require("@/api/rp/outPocCost").default,
      rpApi: require("@/api/rp/outPocCostDts").default,
      code_api: require("@/api/sy/serialCode").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      data: {
        OutPocCostId: 0,
        DocNo: "", //单据编号
        DocDate: this.$commonJs.getToday(),
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        BusinessTypeId: null, //业务类型
        InvoiceType: null, //票据类型
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        PayAmount: null, //付款金额
        RemainAmount: null, //未付金额
        Remark: "", //备注
        RpOutPocCostDts: [], //明细
      },
      DelRpOutPocCostDts: [],
      tradeUnitList: [],
      Mode: 0,
      rules: {
        DocNo: [{ required: true, message: "单据编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        TradeUnitId: [{ required: true, message: "请选择外协单位" }],
      },
    };
  },
  computed: {
    isDetails() {
      return Boolean(this.data.Status === 2);
    },
    isSave() {
      return Boolean(this.data.OutPocCostId > 0);
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/machiningcost");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/dealings/machiningcost");
    },
    canReview() {
      return this.$permission.canReview("/finance/dealings/machiningcost");
    },
  },
  beforeMount() {
    this.onOpened();
    this.getCurd();
  },
  methods: {
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({ TradeUnitType: 3 ,Status:1});
        // that.getData();
      });
    },
    setTradeunit(data) {
      // this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    previewNo(dateTime = "") {
      this.code_api.previewNo("委外费用单", dateTime).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取委外费用单编号失败");
        }
      });
    },
    getCurd() {
      const mode = this.$route.params.mode;
      const row = this.$route.params.data ?? {};
      switch (mode) {
        case "create":
          this.onCreateOpened();
          break;
        case "edit":
          this.onEditOpened(row);
          break;
        case "editById":
          this.onEditOpened(row);
          break;
        case "details":
          this.onDetailsOpened(row);
          break;
        case "review":
          this.onReviewed(row);
          break;
        default:
          this.onCreateOpened();
          break;
      }
    },
    // 打开时获取显示显示列表
    onOpened() {
      this.tradeUnitApi.list({ TradeUnitType: 3 ,Status:1}).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
    },
    onCreateOpened() {
      const user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.previewNo();
      this.data.DocDate = this.$commonJs.getToday();
    },
    onEditOpened(data) {
      this.api.info(data.OutPocCostId).then((res) => {
        res.Data.RpOutPocCostDts.forEach((x) => (x.T = null));

        this.data = res.Data;
      });
    },
    onDetailsOpened(data) {
      this.api.info(data.OutPocCostId).then((res) => {
        res.Data.RpOutPocCostDts.forEach((x) => (x.T = null));
        this.data = res.Data;
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.onOpened();
      this.onCreateOpened();
      // this.add();

      setTimeout(() => {
        this.$refs.dialog.clearValidate();
      }, 30);
    },
    Review(){
      this.api.examine(this.data.OutPocCostId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.onEditOpened(this.data);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.OutPocCostId == 0) {
        this.$message.warning("订单未保存");
        return;
      }

      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "cancel" : "examine";
          if(data === 'examine'){
            this.save(1);
          }else if(data === 'cancel'){
            this.api[data](this.data.OutPocCostId).then((res) => {
              if (res.Code === 0 && data == "examine") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "cancel") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.onEditOpened(this.data);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.OutPocCostId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.OutPocCostId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    add() {
      if (!this.data.TradeUnitId) {
        this.$message.warning("请先选择外协单位");
        return;
      }
      console.log("选择待结算加工信息");
      this.$refs.selectDialog.openCreate(this.data);
    },
    setRows(data) {
      console.log("设置加工信息", data);
      

      let params = data.map(item => {
        return {
          ProductId: item.ProductId,
          ColorId: item.ColorId,
          ProductSpec: item.ProductSpec,
        }
      })

      let paramsLength = params.length;
      let ps = [];
      for(let i = 0; i < paramsLength; ++i){
        let p = this.rpApi.getHistoryPocUnitPrice(params[i]);
        ps.push(p)
      }

      var loading = this.$loading({
        lock: true,
        text: "正在获取历史价...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      Promise.all(ps).then(res => {
        for(let i = 0; i < res.length; ++i){
          if(res[i].Code === 0){
            if(res[i].Data!=0)
            data[i].PocUnitPrice = res[i].Data;
          }
        }
        
        data.forEach((x) => {
          this.data.RpOutPocCostDts.push({
            T: 0,
            OutPocCostDtsId: 0,
            OutPocCostId: this.data.OutPocCostId,
            // Stage: x.Stage,
            SourceDocId: x.ProductInDocId, //入库单Id
            SourceDtsId: x.ProductInDtsId, //入库单明细Id
            SourceType: 0,
            // ProcessId: x.ProcessId,
            // ProcessName: x.ProcessName,

            WorkDocNo: x.WorkDocNo ?? "",
            InNumber: x.DocNo ?? "",
            // WorkDocNo: "nono",

            MaterialId: x.MaterialId,
            MaterialNo: x.MaterialNo,
            ProductId: x.ProductId,
            ProductNo: x.ProductNo,
            ProductName: x.ProductName,
            ProductSpec: x.ProductSpec,
            UnitName: x.UnitName,
            UnitId: x.UnitId,
            ColorName: x.ColorName,
            ColorId: x.ColorId,
            Quantity: x.Quantity,
            PocUnitPrice: x.PocUnitPrice,
            PropertyName: x.PropertyName,
            PocAmount: Number((x.Quantity * x.PocUnitPrice).toFixed(2))||null,
            SourceDocId: x.DocId,
            SourceDtsId: x.DocProductId,
          });
        });
        loading.close()

      }).catch(err => {
        loading.close()
      })



      

    },
    del(row, index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.T != 0) this.DelRpOutPocCostDts.push({ ...row, T: 2 });
          this.data.RpOutPocCostDts.splice(index, 1);
        })
        .catch(() => {});
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row[type] = this.$commonJs.obj.toNumber(row[type]);
      // console.log("input", row);
      row.PocAmount =  Number((row.Quantity * row.PocUnitPrice).toFixed(2));
    },
    save(type = 0) {
      this.$refs.dialog.validate().then((valid) => {
        if (!valid) return;

        if (this.data.RpOutPocCostDts.length == 0) {
          this.$message.warning("明细列表不能为空");
          return false;
        }
        var quantity = this.data.RpOutPocCostDts.some((x) => x.Quantity <= 0);
        if (quantity) {
          this.$message.warning("明细列表 - 数量不能为空且需大于0");
          return false;
        }
        var pocUnitPrice = this.data.RpOutPocCostDts.some(
          (x) => x.PocUnitPrice <= 0
        );
        if (pocUnitPrice) {
          this.$message.warning("明细列表 - 加工单价不能为空且需大于0");
          return false;
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);

        data.RpOutPocCostDts = data.RpOutPocCostDts.filter((x) => x.T != null);
        console.log(this.DelRpOutPocCostDts,'this.DelRpOutPocCostDts')//删除的数据没有正常添加
        console.log(data.RpOutPocCostDts,'data.RpOutPocCostDts')
        this.DelRpOutPocCostDts.forEach((x) => data.RpOutPocCostDts.push(x));

        data.Products = [];
        console.log("onBeforeSave", JSON.parse(JSON.stringify(data)));
        // console.log(data);
        // return
        this.$refs.dialog.isLoading = true;

        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if(type !== 1){
              this.$message.success(res.Msg);
            }
            const id =
              this.data.OutPocCostId == 0 ? res.Data : this.data.OutPocCostId;
            this.api.info(id).then((result) => {
              result.Data.RpOutPocCostDts.forEach((x) => (x.T = null));
              this.data = result.Data;
              if(type === 1){
                this.Review();
              }
            });
            this.onClosed();
          } else {
            this.$message.error(res.Msg);
          }
        });
        return false;
      });
    },
    onClosed() {
      this.data.RpOutPocCostDts = [];
      this.DelRpOutPocCostDts = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.dropdown-item {
  padding: 5px 10px;
}
.detail-span {
  padding-left: 0;
  display: inline-block;
}
.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}
.dropdown-item {
  padding: 5px 10px;
}
</style>
